"use client";

import { create } from "zustand";

export type ScrollController = {
  start: () => void;
  stop: () => void;
  scrollTo: (y: number) => void;
  reset: () => void;
  refresh: () => void;
};

type ScrollState = {
  scroller: ScrollController | null;
  setScroller: (scroller: ScrollController | null) => void;
};

export const useScrollStore = create<ScrollState>((set, get) => ({
  scroller: null,
  setScroller: (scroller) => set({ scroller }),
}));

export const getScroller = (): ScrollController | null =>
  useScrollStore.getState().scroller;

